var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"affixStyle",class:{isCollapse:!_vm.isCollapse},style:(`--paddingLeft:${_vm.paddigLeft}px`)},[_c('div',{staticClass:"align-right"},[_vm._t("button")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }